import { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useIsAdmin } from '../hooks/useFeatureFlag';
import NotificationBell from './NotificationBell';
import InviteLinkModal from './InviteLinkModal';

function Navbar() {
  const navigate = useNavigate();
  const { isAuthenticated, user, logout } = useAuth();
  const isAdmin = useIsAdmin();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const profileMenuRef = useRef(null);

  const handleLogout = () => {
    logout();
    navigate('/');
    setMobileMenuOpen(false);
    setProfileDropdownOpen(false);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleProfileDropdown = () => {
    setProfileDropdownOpen(!profileDropdownOpen);
  };

  const closeProfileDropdown = () => {
    setProfileDropdownOpen(false);
    closeMobileMenu();
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
        setProfileDropdownOpen(false);
      }
    };

    if (profileDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [profileDropdownOpen]);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to={isAuthenticated ? "/map" : "/"} className="nav-brand">
          CornerPocket
        </Link>

        <div className="nav-actions">
          {isAuthenticated && <div className="notification-bell-mobile"><NotificationBell /></div>}

          <button
            className="hamburger-menu"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span className={`hamburger-icon ${mobileMenuOpen ? 'open' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>

        <ul className={`nav-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <li><NavLink to="/map" onClick={closeMobileMenu}>Play Pool</NavLink></li>
          <li><NavLink to="/leaderboard" onClick={closeMobileMenu}>Leaderboard</NavLink></li>

          {isAuthenticated ? (
            <>
              <li><NavLink to="/friends" onClick={closeMobileMenu}>Friends</NavLink></li>
              <li className="notification-bell-desktop"><NotificationBell /></li>
              <li className={`profile-menu ${profileDropdownOpen ? 'open' : ''}`} ref={profileMenuRef}>
                <span className="username-link" onClick={toggleProfileDropdown}>
                  {user?.username}
                  <span className="dropdown-caret">▼</span>
                </span>
                <div className="profile-dropdown">
                  <Link to={`/profile/${user?.id}`} onClick={closeProfileDropdown}>View Profile</Link>
                  {isAdmin && <Link to="/admin" onClick={closeProfileDropdown}>Admin Panel</Link>}
                  <button
                    onClick={() => {
                      setShowInviteModal(true);
                      closeProfileDropdown();
                    }}
                    className="btn-link"
                  >
                    Invite Friends
                  </button>
                  <Link to="/feedback" onClick={closeProfileDropdown}>Submit Feedback</Link>
                  <button onClick={handleLogout} className="btn-link">Logout</button>
                </div>
              </li>
            </>
          ) : (
            <>
              <li><Link to="/login" className="btn btn-secondary" onClick={closeMobileMenu}>Log In</Link></li>
              <li><Link to="/register" className="btn btn-primary" onClick={closeMobileMenu}>Sign Up</Link></li>
            </>
          )}
        </ul>
      </div>

      {/* Invite Link Modal */}
      <InviteLinkModal show={showInviteModal} onClose={() => setShowInviteModal(false)} />
    </nav>
  );
}

export default Navbar;
